import { ITranslations } from 'types/common';
import { MapBoxTransFields } from './types';
import en from 'translations/en/mapBox.json';
import pl from 'translations/pl/mapBox.json';
import sl from 'translations/sl/mapBox.json';

export const mapBoxTranslations: ITranslations<MapBoxTransFields> = {
  name: 'mapBox',
  en,
  pl,
  sl,
};
